import { QueryConfig } from "store/utils/query-config";

export const holidayQuotesXDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["createdAt"]
  }
};
